import { Paper, Stack, Tab, Tabs, Typography } from "@mui/material";
import TimeseriesPayout from "./partials/Timeseries";
import { useEffect, useState } from "react";
import useQueryState from "../../../../../../hooks/useQueryState";

const PayoutChart = () => {
  const {
    queryState: { season },
  } = useQueryState();
  const [seasonTab, setSeasonTab] = useState(season[0] ?? "1");

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setSeasonTab(`${newValue}`);
  };

  useEffect(() => {
    if (season.length === 1) {
      setSeasonTab(season[0]);
    }
  }, [season]);

  return (
    <Stack component={Paper} flex={1} minWidth={0} minHeight={0}>
      <Tabs
        value={seasonTab}
        onChange={handleChangeTab}
        sx={{
          minHeight: 42,
          height: 42,
          "& .MuiTab-root": {
            minHeight: 42,
            height: 42,
            padding: "0 12px",
          },
          width: "100%",
          "& .MuiTab-root.Mui-selected": {
            color: "#2146A4",
          },
          "& .MuiTabs-indicator": {
            borderBottom: "2px solid #2146A4",
          },
        }}
      >
        {Array.from({ length: 2 }).map((_, index) => {
          const seasonValue = `${index + 1}`;

          // if (!season.includes(seasonValue)) return null;

          return (
            <Tab
              key={seasonValue}
              value={`${seasonValue}`}
              disabled={!season.includes(seasonValue)}
              label={
                <Typography
                  lineHeight="24px"
                  letterSpacing="0.4px"
                  variant="subtitle2"
                  fontWeight={600}
                >
                  {`Season ${seasonValue}`}
                </Typography>
              }
            />
          );
        })}
      </Tabs>
      <Stack flex={1} gap={1} minHeight={0} minWidth={0} overflow="hidden">
        <Stack py={0.5} px={2} gap={0.25}>
          <Typography variant="subtitle1">Anomalies</Typography>
          <Typography variant="subtitle2">
            Based on all periods selected for each anomaly
          </Typography>
        </Stack>
        <Stack flex={1} minHeight={0} minWidth={0} overflow="hidden">
          <TimeseriesPayout season={`${Number(seasonTab) - 1}`} />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default PayoutChart;
